import { useState, useEffect } from 'react';
import isEqual from 'lodash-es/isEqual';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

type LocationData = { id: string; name?: string };

export const useGetFilteredLocations = () => {
  const [filteredLocations, setFilteredLocations] = useState<LocationData[]>([]);
  const { getScopeName } = useAppScopeStore();
  const { getFeatureFlagLocationMap } = useScopedAppFlagStore();

  const allowedLocations = getFeatureFlagLocationMap('new-task-center-experience');

  useEffect(() => {
    const updatedLocations: LocationData[] = [];
    for (const locId in allowedLocations) {
      if (allowedLocations[locId]?.value) {
        updatedLocations.push({ id: locId, name: getScopeName(locId) });
      }
    }

    if (!isEqual(filteredLocations, updatedLocations)) {
      setFilteredLocations(updatedLocations);
    }
  }, [allowedLocations]);

  // return the id array and return the id with name array
  return filteredLocations;
};
